export default {
	content: `We're currently having issues with our vehicle list. Vehicle cards may not display all information, and filtering and sorting are temporarily unavailable.\n\nWe're working to resolve this as quickly as possible. In the meantime, you can download the CSV file or browse the vehicles using the cards below to place your bids.`,
	contentNoVehicles: `We're currently having issues with our vehicle list. We're working to resolve this as quickly as possible.`,
	downloadCsv: 'Download CSV file',
	heading: "We're experiencing technical difficulties",
	showVehiclesLoading: 'Loading...',
};
